import { useEffect } from "react";

const googleApiKey = import.meta.env.VITE_REACT_APP_GOOGLE_API_KEY;

export function useInitGoogleMaps() {
  useEffect(() => {
    if (!document.getElementById("google-maps-api")) {
      const loadGoogleMapsScript = () => {
        const script = document.createElement("script");
        script.id = "google-maps-api";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&loading=async`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      };
      if (!(window as any).google) {
        loadGoogleMapsScript();
      }
    }
  }, []);
}
